import { render, staticRenderFns } from "./CityBorderLayer.vue?vue&type=template&id=68142839&"
import script from "./CityBorderLayer.vue?vue&type=script&lang=js&"
export * from "./CityBorderLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports